webpackJsonp([43329739329581],{

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _svg = __webpack_require__(170);
	
	var icons = _interopRequireWildcard(_svg);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Icon = function Icon(props) {
	  var type = props.type,
	      color = props.color,
	      height = props.height,
	      width = props.width,
	      label = props.label,
	      className = props.className,
	      iconClassName = props.iconClassName,
	      labelClassName = props.labelClassName,
	      restProps = _objectWithoutProperties(props, ['type', 'color', 'height', 'width', 'label', 'className', 'iconClassName', 'labelClassName']);
	
	  var TheIcon = icons[type];
	  var classes = 'icon ' + className;
	  var style = {};
	  if (color) {
	    style.fill = color;
	  }
	  var labelOut = label ? _react2.default.createElement(
	    'span',
	    { className: labelClassName },
	    label
	  ) : null;
	
	  return _react2.default.createElement(
	    'div',
	    _extends({ className: classes, style: style }, restProps),
	    _react2.default.createElement(TheIcon, { height: height, width: width, className: iconClassName }),
	    labelOut
	  );
	};
	
	Icon.propTypes = {
	  type: _propTypes2.default.string.isRequired,
	  color: _propTypes2.default.string,
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  label: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  iconClassName: _propTypes2.default.string,
	  labelClassName: _propTypes2.default.string
	};
	
	Icon.defaultProps = {
	  color: undefined,
	  height: 32,
	  width: 32,
	  label: '',
	  className: '',
	  iconClassName: '',
	  labelClassName: ''
	};
	
	exports.default = Icon;
	module.exports = exports['default'];

/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Icon = __webpack_require__(147);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Icon2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconCheckmark = function IconCheckmark(props) {
	  var height = props.height,
	      width = props.width,
	      className = props.className;
	
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      version: '1.1',
	      xmlns: 'http://www.w3.org/2000/svg',
	      className: className,
	      width: width,
	      height: height,
	      viewBox: '0 0 32 32'
	    },
	    _react2.default.createElement(
	      'title',
	      null,
	      'Checkmark icon'
	    ),
	    _react2.default.createElement('path', { d: 'M27 4l-15 15-7-7-5 5 12 12 20-20z' })
	  );
	};
	
	IconCheckmark.propTypes = {
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  className: _propTypes2.default.string
	};
	
	IconCheckmark.defaultProps = {
	  height: 32,
	  width: 32,
	  className: ''
	};
	
	exports.default = IconCheckmark;
	module.exports = exports['default'];

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconCogs = function IconCogs(props) {
	  var height = props.height,
	      width = props.width,
	      className = props.className;
	
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      version: '1.1',
	      xmlns: 'http://www.w3.org/2000/svg',
	      className: className,
	      width: width,
	      height: height,
	      viewBox: '0 0 32 32'
	    },
	    _react2.default.createElement(
	      'title',
	      null,
	      'Cogs icon'
	    ),
	    _react2.default.createElement('path', { d: 'M11.366 22.564l1.291-1.807-1.414-1.414-1.807 1.291c-0.335-0.187-0.694-0.337-1.071-0.444l-0.365-2.19h-2l-0.365 2.19c-0.377 0.107-0.736 0.256-1.071 0.444l-1.807-1.291-1.414 1.414 1.291 1.807c-0.187 0.335-0.337 0.694-0.443 1.071l-2.19 0.365v2l2.19 0.365c0.107 0.377 0.256 0.736 0.444 1.071l-1.291 1.807 1.414 1.414 1.807-1.291c0.335 0.187 0.694 0.337 1.071 0.444l0.365 2.19h2l0.365-2.19c0.377-0.107 0.736-0.256 1.071-0.444l1.807 1.291 1.414-1.414-1.291-1.807c0.187-0.335 0.337-0.694 0.444-1.071l2.19-0.365v-2l-2.19-0.365c-0.107-0.377-0.256-0.736-0.444-1.071zM7 27c-1.105 0-2-0.895-2-2s0.895-2 2-2 2 0.895 2 2-0.895 2-2 2zM32 12v-2l-2.106-0.383c-0.039-0.251-0.088-0.499-0.148-0.743l1.799-1.159-0.765-1.848-2.092 0.452c-0.132-0.216-0.273-0.426-0.422-0.629l1.219-1.761-1.414-1.414-1.761 1.219c-0.203-0.149-0.413-0.29-0.629-0.422l0.452-2.092-1.848-0.765-1.159 1.799c-0.244-0.059-0.492-0.109-0.743-0.148l-0.383-2.106h-2l-0.383 2.106c-0.251 0.039-0.499 0.088-0.743 0.148l-1.159-1.799-1.848 0.765 0.452 2.092c-0.216 0.132-0.426 0.273-0.629 0.422l-1.761-1.219-1.414 1.414 1.219 1.761c-0.149 0.203-0.29 0.413-0.422 0.629l-2.092-0.452-0.765 1.848 1.799 1.159c-0.059 0.244-0.109 0.492-0.148 0.743l-2.106 0.383v2l2.106 0.383c0.039 0.251 0.088 0.499 0.148 0.743l-1.799 1.159 0.765 1.848 2.092-0.452c0.132 0.216 0.273 0.426 0.422 0.629l-1.219 1.761 1.414 1.414 1.761-1.219c0.203 0.149 0.413 0.29 0.629 0.422l-0.452 2.092 1.848 0.765 1.159-1.799c0.244 0.059 0.492 0.109 0.743 0.148l0.383 2.106h2l0.383-2.106c0.251-0.039 0.499-0.088 0.743-0.148l1.159 1.799 1.848-0.765-0.452-2.092c0.216-0.132 0.426-0.273 0.629-0.422l1.761 1.219 1.414-1.414-1.219-1.761c0.149-0.203 0.29-0.413 0.422-0.629l2.092 0.452 0.765-1.848-1.799-1.159c0.059-0.244 0.109-0.492 0.148-0.743l2.106-0.383zM21 15.35c-2.402 0-4.35-1.948-4.35-4.35s1.948-4.35 4.35-4.35 4.35 1.948 4.35 4.35c0 2.402-1.948 4.35-4.35 4.35z' })
	  );
	};
	
	IconCogs.propTypes = {
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  className: _propTypes2.default.string
	};
	
	IconCogs.defaultProps = {
	  height: 32,
	  width: 32,
	  className: ''
	};
	
	exports.default = IconCogs;
	module.exports = exports['default'];

/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconDatabase = function IconDatabase(props) {
	  var height = props.height,
	      width = props.width,
	      className = props.className;
	
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      version: '1.1',
	      xmlns: 'http://www.w3.org/2000/svg',
	      className: className,
	      width: width,
	      height: height,
	      viewBox: '0 0 32 32'
	    },
	    _react2.default.createElement(
	      'title',
	      null,
	      'Database icon'
	    ),
	    _react2.default.createElement('path', { d: 'M16 0c-8.837 0-16 2.239-16 5v4c0 2.761 7.163 5 16 5s16-2.239 16-5v-4c0-2.761-7.163-5-16-5z' }),
	    _react2.default.createElement('path', { d: 'M16 17c-8.837 0-16-2.239-16-5v6c0 2.761 7.163 5 16 5s16-2.239 16-5v-6c0 2.761-7.163 5-16 5z' }),
	    _react2.default.createElement('path', { d: 'M16 26c-8.837 0-16-2.239-16-5v6c0 2.761 7.163 5 16 5s16-2.239 16-5v-6c0 2.761-7.163 5-16 5z' })
	  );
	};
	
	IconDatabase.propTypes = {
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  className: _propTypes2.default.string
	};
	
	IconDatabase.defaultProps = {
	  height: 32,
	  width: 32,
	  className: ''
	};
	
	exports.default = IconDatabase;
	module.exports = exports['default'];

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconDisplay = function IconDisplay(props) {
	  var height = props.height,
	      width = props.width,
	      className = props.className;
	
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      version: '1.1',
	      xmlns: 'http://www.w3.org/2000/svg',
	      className: className,
	      width: width,
	      height: height,
	      viewBox: '0 0 32 32'
	    },
	    _react2.default.createElement(
	      'title',
	      null,
	      'Display icon'
	    ),
	    _react2.default.createElement('path', { d: 'M0 2v20h32v-20h-32zM30 20h-28v-16h28v16zM21 24h-10l-1 4-2 2h16l-2-2z' })
	  );
	};
	
	IconDisplay.propTypes = {
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  className: _propTypes2.default.string
	};
	
	IconDisplay.defaultProps = {
	  height: 32,
	  width: 32,
	  className: ''
	};
	
	exports.default = IconDisplay;
	module.exports = exports['default'];

/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconDownload = function IconDownload(props) {
	  var height = props.height,
	      width = props.width,
	      className = props.className;
	
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      version: '1.1',
	      xmlns: 'http://www.w3.org/2000/svg',
	      className: className,
	      width: width,
	      height: height,
	      viewBox: '0 0 32 32'
	    },
	    _react2.default.createElement(
	      'title',
	      null,
	      'Download icon'
	    ),
	    _react2.default.createElement('path', { d: 'M24.615 27.076c0-0.673-0.558-1.231-1.231-1.231s-1.231 0.558-1.231 1.231 0.558 1.231 1.231 1.231 1.231-0.558 1.231-1.231zM29.538 27.076c0-0.673-0.558-1.231-1.231-1.231s-1.231 0.558-1.231 1.231 0.558 1.231 1.231 1.231 1.231-0.558 1.231-1.231zM31.999 22.769v6.154c0 1.019-0.827 1.846-1.846 1.846h-28.306c-1.019 0-1.846-0.827-1.846-1.846v-6.154c0-1.019 0.827-1.846 1.846-1.846h8.942l2.596 2.615c0.712 0.692 1.635 1.077 2.615 1.077s1.904-0.385 2.615-1.077l2.615-2.615h8.923c1.019 0 1.846 0.827 1.846 1.846zM25.749 11.827c0.192 0.461 0.096 1-0.269 1.346l-8.615 8.615c-0.231 0.25-0.558 0.365-0.865 0.365s-0.635-0.115-0.865-0.365l-8.615-8.615c-0.365-0.346-0.462-0.885-0.269-1.346 0.192-0.442 0.635-0.75 1.135-0.75h4.923v-8.615c0-0.673 0.558-1.231 1.231-1.231h4.923c0.673 0 1.231 0.558 1.231 1.231v8.615h4.923c0.5 0 0.942 0.308 1.135 0.75z' })
	  );
	};
	
	IconDownload.propTypes = {
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  className: _propTypes2.default.string
	};
	
	IconDownload.defaultProps = {
	  height: 32,
	  width: 32,
	  className: ''
	};
	
	exports.default = IconDownload;
	module.exports = exports['default'];

/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconEmbed = function IconEmbed(props) {
	  var height = props.height,
	      width = props.width,
	      className = props.className;
	
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      version: '1.1',
	      xmlns: 'http://www.w3.org/2000/svg',
	      className: className,
	      width: width,
	      height: height,
	      viewBox: '0 0 40 32'
	    },
	    _react2.default.createElement(
	      'title',
	      null,
	      'Embed icon'
	    ),
	    _react2.default.createElement('path', { d: 'M26 23l3 3 10-10-10-10-3 3 7 7z' }),
	    _react2.default.createElement('path', { d: 'M14 9l-3-3-10 10 10 10 3-3-7-7z' }),
	    _react2.default.createElement('path', { d: 'M21.916 4.704l2.171 0.592-6 22.001-2.171-0.592 6-22.001z' })
	  );
	};
	
	IconEmbed.propTypes = {
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  className: _propTypes2.default.string
	};
	
	IconEmbed.defaultProps = {
	  height: 32,
	  width: 32,
	  className: ''
	};
	
	exports.default = IconEmbed;
	module.exports = exports['default'];

/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconGitHub = function IconGitHub(props) {
	  var height = props.height,
	      width = props.width,
	      className = props.className;
	
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      version: '1.1',
	      xmlns: 'http://www.w3.org/2000/svg',
	      className: className,
	      width: width,
	      height: height,
	      viewBox: '0 0 16 16'
	    },
	    _react2.default.createElement(
	      'title',
	      null,
	      'GitHub icon'
	    ),
	    _react2.default.createElement('path', {
	      fillRule: 'evenodd',
	      d: 'M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0 0 16 8c0-4.42-3.58-8-8-8z'
	    })
	  );
	};
	
	IconGitHub.propTypes = {
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  className: _propTypes2.default.string
	};
	
	IconGitHub.defaultProps = {
	  height: 32,
	  width: 32,
	  className: ''
	};
	
	exports.default = IconGitHub;
	module.exports = exports['default'];

/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconLinkedIn = function IconLinkedIn(props) {
	  var height = props.height,
	      width = props.width,
	      className = props.className;
	
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      version: '1.1',
	      xmlns: 'http://www.w3.org/2000/svg',
	      className: className,
	      width: width,
	      height: height,
	      viewBox: '0 0 32 32'
	    },
	    _react2.default.createElement(
	      'title',
	      null,
	      'LinkedIn icon'
	    ),
	    _react2.default.createElement('path', { d: 'M12 12h5.535v2.837h0.079c0.77-1.381 2.655-2.837 5.464-2.837 5.842 0 6.922 3.637 6.922 8.367v9.633h-5.769v-8.54c0-2.037-0.042-4.657-3.001-4.657-3.005 0-3.463 2.218-3.463 4.509v8.688h-5.767v-18z' }),
	    _react2.default.createElement('path', { d: 'M2 12h6v18h-6v-18z' }),
	    _react2.default.createElement('path', { d: 'M8 7c0 1.657-1.343 3-3 3s-3-1.343-3-3c0-1.657 1.343-3 3-3s3 1.343 3 3z' })
	  );
	};
	
	IconLinkedIn.propTypes = {
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  className: _propTypes2.default.string
	};
	
	IconLinkedIn.defaultProps = {
	  height: 32,
	  width: 32,
	  className: ''
	};
	
	exports.default = IconLinkedIn;
	module.exports = exports['default'];

/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconLocation = function IconLocation(props) {
	  var height = props.height,
	      width = props.width,
	      className = props.className;
	
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      version: '1.1',
	      xmlns: 'http://www.w3.org/2000/svg',
	      className: className,
	      width: width,
	      height: height,
	      viewBox: '0 0 32 32'
	    },
	    _react2.default.createElement(
	      'title',
	      null,
	      'Location icon'
	    ),
	    _react2.default.createElement('path', { d: 'M16 0c-5.523 0-10 4.477-10 10 0 10 10 22 10 22s10-12 10-22c0-5.523-4.477-10-10-10zM16 16c-3.314 0-6-2.686-6-6s2.686-6 6-6 6 2.686 6 6-2.686 6-6 6z' })
	  );
	};
	
	IconLocation.propTypes = {
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  className: _propTypes2.default.string
	};
	
	IconLocation.defaultProps = {
	  height: 32,
	  width: 32,
	  className: ''
	};
	
	exports.default = IconLocation;
	module.exports = exports['default'];

/***/ }),

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconMail = function IconMail(props) {
	  var height = props.height,
	      width = props.width,
	      className = props.className;
	
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      version: '1.1',
	      xmlns: 'http://www.w3.org/2000/svg',
	      className: className,
	      width: width,
	      height: height,
	      viewBox: '0 0 32 32'
	    },
	    _react2.default.createElement(
	      'title',
	      null,
	      'Mail icon'
	    ),
	    _react2.default.createElement('path', { d: 'M32 12.679v14.179c0 1.571-1.286 2.857-2.857 2.857h-26.286c-1.571 0-2.857-1.286-2.857-2.857v-14.179c0.536 0.589 1.143 1.107 1.804 1.554 2.964 2.018 5.964 4.036 8.875 6.161 1.5 1.107 3.357 2.464 5.304 2.464h0.036c1.946 0 3.804-1.357 5.304-2.464 2.911-2.107 5.911-4.143 8.893-6.161 0.643-0.446 1.25-0.964 1.786-1.554zM32 7.429c0 2-1.482 3.804-3.054 4.893-2.786 1.929-5.589 3.857-8.357 5.804-1.161 0.804-3.125 2.446-4.571 2.446h-0.036c-1.446 0-3.411-1.643-4.571-2.446-2.768-1.946-5.571-3.875-8.339-5.804-1.268-0.857-3.071-2.875-3.071-4.5 0-1.75 0.946-3.25 2.857-3.25h26.286c1.554 0 2.857 1.286 2.857 2.857z' })
	  );
	};
	
	IconMail.propTypes = {
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  className: _propTypes2.default.string
	};
	
	IconMail.defaultProps = {
	  height: 32,
	  width: 32,
	  className: ''
	};
	
	exports.default = IconMail;
	module.exports = exports['default'];

/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconMenu = function IconMenu(props) {
	  var height = props.height,
	      width = props.width,
	      className = props.className;
	
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      className: className,
	      width: width,
	      height: height,
	      viewBox: '0 0 24 32'
	    },
	    _react2.default.createElement('path', { d: 'M0 6v4h24V6H0zm0 12h24v-4H0v4zm0 8h24v-4H0v4z' })
	  );
	};
	
	IconMenu.propTypes = {
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  className: _propTypes2.default.string
	};
	
	IconMenu.defaultProps = {
	  height: 32,
	  width: 32,
	  className: ''
	};
	
	exports.default = IconMenu;
	module.exports = exports['default'];

/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconMeter = function IconMeter(props) {
	  var height = props.height,
	      width = props.width,
	      className = props.className;
	
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      version: '1.1',
	      xmlns: 'http://www.w3.org/2000/svg',
	      className: className,
	      width: width,
	      height: height,
	      viewBox: '0 0 16 16'
	    },
	    _react2.default.createElement(
	      'title',
	      null,
	      'Meter icon'
	    ),
	    _react2.default.createElement('path', {
	      fillRule: 'evenodd',
	      d: 'M9 5H8V4h1v1zm4 3h-1v1h1V8zM6 5H5v1h1V5zM5 8H4v1h1V8zm11-5.5l-.5-.5L9 7c-.06-.02-1 0-1 0-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-.92l6-5.58zm-1.59 4.09c.19.61.3 1.25.3 1.91 0 3.42-2.78 6.2-6.2 6.2-3.42 0-6.21-2.78-6.21-6.2 0-3.42 2.78-6.2 6.2-6.2 1.2 0 2.31.34 3.27.94l.94-.94A7.459 7.459 0 0 0 8.51 1C4.36 1 1 4.36 1 8.5 1 12.64 4.36 16 8.5 16c4.14 0 7.5-3.36 7.5-7.5 0-1.03-.2-2.02-.59-2.91l-1 1z'
	    })
	  );
	};
	
	IconMeter.propTypes = {
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  className: _propTypes2.default.string
	};
	
	IconMeter.defaultProps = {
	  height: 32,
	  width: 32,
	  className: ''
	};
	
	exports.default = IconMeter;
	module.exports = exports['default'];

/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconMobile = function IconMobile(props) {
	  var height = props.height,
	      width = props.width,
	      className = props.className;
	
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      version: '1.1',
	      xmlns: 'http://www.w3.org/2000/svg',
	      className: className,
	      width: width,
	      height: height,
	      viewBox: '0 0 32 32'
	    },
	    _react2.default.createElement(
	      'title',
	      null,
	      'Mobile icon'
	    ),
	    _react2.default.createElement('path', { d: 'M23 0h-14c-1.65 0-3 1.35-3 3v26c0 1.65 1.35 3 3 3h14c1.65 0 3-1.35 3-3v-26c0-1.65-1.35-3-3-3zM12 1.5h8v1h-8v-1zM16 30c-1.105 0-2-0.895-2-2s0.895-2 2-2 2 0.895 2 2-0.895 2-2 2zM24 24h-16v-20h16v20z' })
	  );
	};
	
	IconMobile.propTypes = {
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  className: _propTypes2.default.string
	};
	
	IconMobile.defaultProps = {
	  height: 32,
	  width: 32,
	  className: ''
	};
	
	exports.default = IconMobile;
	module.exports = exports['default'];

/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconPackage = function IconPackage(props) {
	  var height = props.height,
	      width = props.width,
	      className = props.className;
	
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      version: '1.1',
	      xmlns: 'http://www.w3.org/2000/svg',
	      className: className,
	      width: width,
	      height: height,
	      viewBox: '0 0 16 16'
	    },
	    _react2.default.createElement(
	      'title',
	      null,
	      'Package icon'
	    ),
	    _react2.default.createElement('path', {
	      fillRule: 'evenodd',
	      d: 'M1 4.27v7.47c0 .45.3.84.75.97l6.5 1.73c.16.05.34.05.5 0l6.5-1.73c.45-.13.75-.52.75-.97V4.27c0-.45-.3-.84-.75-.97l-6.5-1.74a1.4 1.4 0 0 0-.5 0L1.75 3.3c-.45.13-.75.52-.75.97zm7 9.09l-6-1.59V5l6 1.61v6.75zM2 4l2.5-.67L11 5.06l-2.5.67L2 4zm13 7.77l-6 1.59V6.61l2-.55V8.5l2-.53V5.53L15 5v6.77zm-2-7.24L6.5 2.8l2-.53L15 4l-2 .53z'
	    })
	  );
	};
	
	IconPackage.propTypes = {
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  className: _propTypes2.default.string
	};
	
	IconPackage.defaultProps = {
	  height: 32,
	  width: 32,
	  className: ''
	};
	
	exports.default = IconPackage;
	module.exports = exports['default'];

/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconPhone = function IconPhone(props) {
	  var height = props.height,
	      width = props.width,
	      className = props.className;
	
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      version: '1.1',
	      xmlns: 'http://www.w3.org/2000/svg',
	      className: className,
	      width: width,
	      height: height,
	      viewBox: '0 0 32 32'
	    },
	    _react2.default.createElement(
	      'title',
	      null,
	      'Phone icon'
	    ),
	    _react2.default.createElement('path', { d: 'M22 20c-2 2-2 4-4 4s-4-2-6-4-4-4-4-6 2-2 4-4-4-8-6-8-6 6-6 6c0 4 4.109 12.109 8 16s12 8 16 8c0 0 6-4 6-6s-6-8-8-6z' })
	  );
	};
	
	IconPhone.propTypes = {
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  className: _propTypes2.default.string
	};
	
	IconPhone.defaultProps = {
	  height: 32,
	  width: 32,
	  className: ''
	};
	
	exports.default = IconPhone;
	module.exports = exports['default'];

/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconSphere = function IconSphere(props) {
	  var height = props.height,
	      width = props.width,
	      className = props.className;
	
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      version: '1.1',
	      xmlns: 'http://www.w3.org/2000/svg',
	      className: className,
	      width: width,
	      height: height,
	      viewBox: '0 0 32 32'
	    },
	    _react2.default.createElement(
	      'title',
	      null,
	      'Sphere icon'
	    ),
	    _react2.default.createElement('path', { d: 'M15 2c-8.284 0-15 6.716-15 15s6.716 15 15 15c8.284 0 15-6.716 15-15s-6.716-15-15-15zM23.487 22c0.268-1.264 0.437-2.606 0.492-4h3.983c-0.104 1.381-0.426 2.722-0.959 4h-3.516zM6.513 12c-0.268 1.264-0.437 2.606-0.492 4h-3.983c0.104-1.381 0.426-2.722 0.959-4h3.516zM21.439 12c0.3 1.28 0.481 2.62 0.54 4h-5.979v-4h5.439zM16 10v-5.854c0.456 0.133 0.908 0.355 1.351 0.668 0.831 0.586 1.625 1.488 2.298 2.609 0.465 0.775 0.867 1.638 1.203 2.578h-4.852zM10.351 7.422c0.673-1.121 1.467-2.023 2.298-2.609 0.443-0.313 0.895-0.535 1.351-0.668v5.854h-4.852c0.336-0.94 0.738-1.803 1.203-2.578zM14 12v4h-5.979c0.059-1.38 0.24-2.72 0.54-4h5.439zM2.997 22c-0.533-1.278-0.854-2.619-0.959-4h3.983c0.055 1.394 0.224 2.736 0.492 4h-3.516zM8.021 18h5.979v4h-5.439c-0.3-1.28-0.481-2.62-0.54-4zM14 24v5.854c-0.456-0.133-0.908-0.355-1.351-0.668-0.831-0.586-1.625-1.488-2.298-2.609-0.465-0.775-0.867-1.638-1.203-2.578h4.852zM19.649 26.578c-0.673 1.121-1.467 2.023-2.298 2.609-0.443 0.312-0.895 0.535-1.351 0.668v-5.854h4.852c-0.336 0.94-0.738 1.802-1.203 2.578zM16 22v-4h5.979c-0.059 1.38-0.24 2.72-0.54 4h-5.439zM23.98 16c-0.055-1.394-0.224-2.736-0.492-4h3.516c0.533 1.278 0.855 2.619 0.959 4h-3.983zM25.958 10h-2.997c-0.582-1.836-1.387-3.447-2.354-4.732 1.329 0.636 2.533 1.488 3.585 2.54 0.671 0.671 1.261 1.404 1.766 2.192zM5.808 7.808c1.052-1.052 2.256-1.904 3.585-2.54-0.967 1.285-1.771 2.896-2.354 4.732h-2.997c0.504-0.788 1.094-1.521 1.766-2.192zM4.042 24h2.997c0.583 1.836 1.387 3.447 2.354 4.732-1.329-0.636-2.533-1.488-3.585-2.54-0.671-0.671-1.261-1.404-1.766-2.192zM24.192 26.192c-1.052 1.052-2.256 1.904-3.585 2.54 0.967-1.285 1.771-2.896 2.354-4.732h2.997c-0.504 0.788-1.094 1.521-1.766 2.192z' })
	  );
	};
	
	IconSphere.propTypes = {
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  className: _propTypes2.default.string
	};
	
	IconSphere.defaultProps = {
	  height: 32,
	  width: 32,
	  className: ''
	};
	
	exports.default = IconSphere;
	module.exports = exports['default'];

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconStack = function IconStack(props) {
	  var height = props.height,
	      width = props.width,
	      className = props.className;
	
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      version: '1.1',
	      xmlns: 'http://www.w3.org/2000/svg',
	      className: className,
	      width: width,
	      height: height,
	      viewBox: '0 0 32 32'
	    },
	    _react2.default.createElement(
	      'title',
	      null,
	      'Stack icon'
	    ),
	    _react2.default.createElement('path', { d: 'M32 10l-16-8-16 8 16 8 16-8zM16 4.655l10.689 5.345-10.689 5.345-10.689-5.345 10.689-5.345zM28.795 14.398l3.205 1.602-16 8-16-8 3.205-1.602 12.795 6.398zM28.795 20.398l3.205 1.602-16 8-16-8 3.205-1.602 12.795 6.398z' })
	  );
	};
	
	IconStack.propTypes = {
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  className: _propTypes2.default.string
	};
	
	IconStack.defaultProps = {
	  height: 32,
	  width: 32,
	  className: ''
	};
	
	exports.default = IconStack;
	module.exports = exports['default'];

/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconStar = function IconStar(props) {
	  var height = props.height,
	      width = props.width,
	      className = props.className;
	
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      version: '1.1',
	      xmlns: 'http://www.w3.org/2000/svg',
	      className: className,
	      width: width,
	      height: height,
	      viewBox: '0 0 32 32'
	    },
	    _react2.default.createElement(
	      'title',
	      null,
	      'Star icon'
	    ),
	    _react2.default.createElement('path', { d: 'M32 12.408l-11.056-1.607-4.944-10.018-4.944 10.018-11.056 1.607 8 7.798-1.889 11.011 9.889-5.199 9.889 5.199-1.889-11.011 8-7.798z' })
	  );
	};
	
	IconStar.propTypes = {
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  className: _propTypes2.default.string
	};
	
	IconStar.defaultProps = {
	  height: 32,
	  width: 32,
	  className: ''
	};
	
	exports.default = IconStar;
	module.exports = exports['default'];

/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconEmptyStar = function IconEmptyStar(props) {
	  var height = props.height,
	      width = props.width,
	      className = props.className;
	
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      version: '1.1',
	      xmlns: 'http://www.w3.org/2000/svg',
	      className: className,
	      width: width,
	      height: height,
	      viewBox: '0 0 32 32'
	    },
	    _react2.default.createElement(
	      'title',
	      null,
	      'Empty icon'
	    ),
	    _react2.default.createElement('path', { d: 'M32 12.408l-11.056-1.607-4.944-10.018-4.944 10.018-11.056 1.607 8 7.798-1.889 11.011 9.889-5.199 9.889 5.199-1.889-11.011 8-7.798zM16 23.547l-6.983 3.671 1.334-7.776-5.65-5.507 7.808-1.134 3.492-7.075 3.492 7.075 7.807 1.134-5.65 5.507 1.334 7.776-6.983-3.671z' })
	  );
	};
	
	IconEmptyStar.propTypes = {
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  className: _propTypes2.default.string
	};
	
	IconEmptyStar.defaultProps = {
	  height: 32,
	  width: 32,
	  className: ''
	};
	
	exports.default = IconEmptyStar;
	module.exports = exports['default'];

/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconHalfStar = function IconHalfStar(props) {
	  var height = props.height,
	      width = props.width,
	      className = props.className;
	
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      version: '1.1',
	      xmlns: 'http://www.w3.org/2000/svg',
	      className: className,
	      width: width,
	      height: height,
	      viewBox: '0 0 32 32'
	    },
	    _react2.default.createElement(
	      'title',
	      null,
	      'Half Star icon'
	    ),
	    _react2.default.createElement('path', { d: 'M32 12.408l-11.056-1.607-4.944-10.018-4.944 10.018-11.056 1.607 8 7.798-1.889 11.011 9.889-5.199 9.889 5.199-1.889-11.011 8-7.798zM16 23.547l-0.029 0.015 0.029-17.837 3.492 7.075 7.807 1.134-5.65 5.507 1.334 7.776-6.983-3.671z' })
	  );
	};
	
	IconHalfStar.propTypes = {
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  className: _propTypes2.default.string
	};
	
	IconHalfStar.defaultProps = {
	  height: 32,
	  width: 32,
	  className: ''
	};
	
	exports.default = IconHalfStar;
	module.exports = exports['default'];

/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconTerminal = function IconTerminal(props) {
	  var height = props.height,
	      width = props.width,
	      className = props.className;
	
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      version: '1.1',
	      xmlns: 'http://www.w3.org/2000/svg',
	      className: className,
	      width: width,
	      height: height,
	      viewBox: '0 0 14 16'
	    },
	    _react2.default.createElement(
	      'title',
	      null,
	      'Terminal icon'
	    ),
	    _react2.default.createElement('path', {
	      fillRule: 'evenodd',
	      d: 'M7 10h4v1H7v-1zm-3 1l3-3-3-3-.75.75L5.5 8l-2.25 2.25L4 11zm10-8v10c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1h12c.55 0 1 .45 1 1zm-1 0H1v10h12V3z'
	    })
	  );
	};
	
	IconTerminal.propTypes = {
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  className: _propTypes2.default.string
	};
	
	IconTerminal.defaultProps = {
	  height: 32,
	  width: 32,
	  className: ''
	};
	
	exports.default = IconTerminal;
	module.exports = exports['default'];

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconTwitter = function IconTwitter(props) {
	  var height = props.height,
	      width = props.width,
	      className = props.className;
	
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      version: '1.1',
	      xmlns: 'http://www.w3.org/2000/svg',
	      className: className,
	      width: width,
	      height: height,
	      viewBox: '0 0 32 32'
	    },
	    _react2.default.createElement(
	      'title',
	      null,
	      'Twitter icon'
	    ),
	    _react2.default.createElement('path', { d: 'M32 7.075c-1.175 0.525-2.444 0.875-3.769 1.031 1.356-0.813 2.394-2.1 2.887-3.631-1.269 0.75-2.675 1.3-4.169 1.594-1.2-1.275-2.906-2.069-4.794-2.069-3.625 0-6.563 2.938-6.563 6.563 0 0.512 0.056 1.012 0.169 1.494-5.456-0.275-10.294-2.888-13.531-6.862-0.563 0.969-0.887 2.1-0.887 3.3 0 2.275 1.156 4.287 2.919 5.463-1.075-0.031-2.087-0.331-2.975-0.819 0 0.025 0 0.056 0 0.081 0 3.181 2.263 5.838 5.269 6.437-0.55 0.15-1.131 0.231-1.731 0.231-0.425 0-0.831-0.044-1.237-0.119 0.838 2.606 3.263 4.506 6.131 4.563-2.25 1.762-5.075 2.813-8.156 2.813-0.531 0-1.050-0.031-1.569-0.094 2.913 1.869 6.362 2.95 10.069 2.95 12.075 0 18.681-10.006 18.681-18.681 0-0.287-0.006-0.569-0.019-0.85 1.281-0.919 2.394-2.075 3.275-3.394z' })
	  );
	};
	
	IconTwitter.propTypes = {
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  className: _propTypes2.default.string
	};
	
	IconTwitter.defaultProps = {
	  height: 32,
	  width: 32,
	  className: ''
	};
	
	exports.default = IconTwitter;
	module.exports = exports['default'];

/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Checkmark = __webpack_require__(148);
	
	Object.defineProperty(exports, 'IconCheckmark', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Checkmark).default;
	  }
	});
	
	var _Cogs = __webpack_require__(149);
	
	Object.defineProperty(exports, 'IconCogs', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Cogs).default;
	  }
	});
	
	var _Database = __webpack_require__(150);
	
	Object.defineProperty(exports, 'IconDatabase', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Database).default;
	  }
	});
	
	var _Display = __webpack_require__(151);
	
	Object.defineProperty(exports, 'IconDisplay', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Display).default;
	  }
	});
	
	var _Download = __webpack_require__(152);
	
	Object.defineProperty(exports, 'IconDownload', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Download).default;
	  }
	});
	
	var _Embed = __webpack_require__(153);
	
	Object.defineProperty(exports, 'IconEmbed', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Embed).default;
	  }
	});
	
	var _GitHub = __webpack_require__(154);
	
	Object.defineProperty(exports, 'IconGitHub', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GitHub).default;
	  }
	});
	
	var _LinkedIn = __webpack_require__(155);
	
	Object.defineProperty(exports, 'IconLinkedIn', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LinkedIn).default;
	  }
	});
	
	var _Location = __webpack_require__(156);
	
	Object.defineProperty(exports, 'IconLocation', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Location).default;
	  }
	});
	
	var _Mail = __webpack_require__(157);
	
	Object.defineProperty(exports, 'IconMail', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Mail).default;
	  }
	});
	
	var _Menu = __webpack_require__(158);
	
	Object.defineProperty(exports, 'IconMenu', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Menu).default;
	  }
	});
	
	var _Meter = __webpack_require__(159);
	
	Object.defineProperty(exports, 'IconMeter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Meter).default;
	  }
	});
	
	var _Mobile = __webpack_require__(160);
	
	Object.defineProperty(exports, 'IconMobile', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Mobile).default;
	  }
	});
	
	var _Package = __webpack_require__(161);
	
	Object.defineProperty(exports, 'IconPackage', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Package).default;
	  }
	});
	
	var _Phone = __webpack_require__(162);
	
	Object.defineProperty(exports, 'IconPhone', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Phone).default;
	  }
	});
	
	var _Sphere = __webpack_require__(163);
	
	Object.defineProperty(exports, 'IconSphere', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Sphere).default;
	  }
	});
	
	var _Stack = __webpack_require__(164);
	
	Object.defineProperty(exports, 'IconStack', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Stack).default;
	  }
	});
	
	var _Star = __webpack_require__(165);
	
	Object.defineProperty(exports, 'IconStar', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Star).default;
	  }
	});
	
	var _StarHalf = __webpack_require__(167);
	
	Object.defineProperty(exports, 'IconHalfStar', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StarHalf).default;
	  }
	});
	
	var _StarEmpty = __webpack_require__(166);
	
	Object.defineProperty(exports, 'IconEmptyStar', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StarEmpty).default;
	  }
	});
	
	var _Terminal = __webpack_require__(168);
	
	Object.defineProperty(exports, 'IconTerminal', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Terminal).default;
	  }
	});
	
	var _Twitter = __webpack_require__(169);
	
	Object.defineProperty(exports, 'IconTwitter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Twitter).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 673:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(135);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResumeEducation = function ResumeEducation() {
	  return _react2.default.createElement(
	    'section',
	    { className: 'resume--section' },
	    _react2.default.createElement(
	      'h1',
	      { className: 'resume--section-title' },
	      'Education'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'rb-experience-item' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          null,
	          '1993'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'resume--section--block-title' },
	          'BACHELOR OF SCIENCE'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'resume--section--block-subtitle' },
	          'Mechanical Engineering'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'resume--section--block-content' },
	        'Worcester Polytechnic Institute'
	      )
	    )
	  );
	};
	
	exports.default = ResumeEducation;
	module.exports = exports['default'];

/***/ }),

/***/ 674:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(135);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResumeExperience = function ResumeExperience() {
	  return _react2.default.createElement(
	    'section',
	    { className: 'resume--section' },
	    _react2.default.createElement(
	      'h1',
	      { className: 'resume--section-title' },
	      'Professional Experience'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'resume--section--block' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          null,
	          '2015 - present'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'resume--section--block-title' },
	          'Software Developer'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'resume--section--block-subtitle' },
	          'Latitude42 Technology Solutions'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'resume--section--block-content' },
	        _react2.default.createElement(
	          'p',
	          null,
	          'Created web apps/sites and implemented back end enhancements for clients.'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'Worked with clients to understand needs and goals, evaluate requirements and determine appropriate solution.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Evaluated and determined the most suitable technology stacks based on appropriateness for client and project.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Architected infrastructure and software foundations for projects.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Designed and implemented database schemas for persistent storage of application data.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Coded/tested/deployed front and back-end software per project needs.'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'resume--section--block' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          null,
	          '1998 - 2015'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'resume--section--block-title' },
	          'PRINCIPAL CONSULTANT (TEAM LEAD / ARCHITECT / TECHNICAL ANALYST / DEVELOPER)'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'resume--section--block-subtitle' },
	          'NTT Data Americas (formerly Keane, Inc.)'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'resume--section--block-content' },
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Client: New York State Office of Mental Health'
	          ),
	          _react2.default.createElement('br', null),
	          'Created applications for the finance group to simplify management of financial data.'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'A web application with internal and external facing components to automatically notify providers of changes to reimbursement rates and provide online access to rate change and supporting documentation.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Multiple web applications providing a simple workflow style interface encapsulating the complex rules, calculations and checkpoints necessary to modify Medicaid reimbursement rates of health providers.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'A web application to evaluate competing registration requests using a complex set of rules and to maintain an accounting of current and historical registration data.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'A client application similar to a personal income tax program used by mental health providers to simplify data entry and submission of quarterly and annual financial information to the state.'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Responsibilities included:'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'Defined software architecture based on system requirements.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Designed and developed core software components to handle common functionality including security, logging, exception management and validation.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Actively involved in the design and implementation of system frameworks, business components, data access components and cross functional components.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Actively involved in the design and implementation of user interface components with focus on cross-browser compatibility and progressive enhancement of UI functionality.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Designed and implemented data schemas and complex database procedures, application services and browser-based user interfaces using web standard technologies.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Performed performance analysis and tuning of application code, database queries and procedural code.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Designed and implemented automated build and deployment environment.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Developed test cases, unit tests, integration tests and debugging of components in all layers of systems.'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Client: GE Plastics'
	          ),
	          _react2.default.createElement('br', null),
	          'Large scale implementation and customization of Pivotal customer relationship management system including a highly specialized pricing module.'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'Designed and constructed all data loads into the Pivotal system.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Designed and constructed interfaces between Oracle-based systems and Pivotal (SQL Server based) system with focus on ensuring data integrity.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Resolved database design issues and designed interim database to house all data requiring scrubbing and validation before loading into Pivotal system.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Assisted vendor on system design changes, implementation and troubleshooting of Pivotal agents.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Performance tuned servers, network and application; assisted with server configuration.'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Client: Publishers Research Group'
	          ),
	          _react2.default.createElement('br', null),
	          'Implementation of the Pivotal customer relationship management system.'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'Gathered and analyzed requirements.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Designed Pivotal solution and customized the Pivotal system according to design requirements.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Created reports using Crystal Reports.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Set up, configured and maintained MS SQL Server and MS Exchange servers.'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Client: Berkshire Health Systems'
	          ),
	          _react2.default.createElement('br', null),
	          'Migrate existing billing system functions and medical reports to SMS Allegra platform.'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'Analyzed and modified DEC BASIC programs to support upgrade to SMS Allegra.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Analyzed, coded and tested programs, interfaces and report components necessary for the migration effort.'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'resume--section--block' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          null,
	          '1996 - 1998'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'resume--section--block-title' },
	          'APPLICATION ENGINEER'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'resume--section--block-subtitle' },
	          'GE Fanuc Automation'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'resume--section--block-content' },
	        _react2.default.createElement(
	          'p',
	          null,
	          'Worked directly with customers to design and develop custom industrial automation solutions.'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'Prepared proposals and specifications for customer projects in a manufacturing environment.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Developed custom applications based on specifications and time commitments.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Demonstrated and supported product / project capabilities to customers.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Provided telephone and on-site technical support to customers in the areas of software functionality and problem resolution, operating system usage, application programming interface issues, and hardware / software interface issues.'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = ResumeExperience;
	module.exports = exports['default'];

/***/ }),

/***/ 675:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(97);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	__webpack_require__(135);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResumeHeader = function ResumeHeader() {
	  var resumeBasic = ("JodyBoucher-Resume-Basic-5ba15bf6a15dafa2ca8e.pdf");
	  var resumeModern = ("JodyBoucher-Resume-Modern-3f2b3decc7c57fde954a.pdf");
	
	  return _react2.default.createElement(
	    'section',
	    { className: 'resume--section' },
	    _react2.default.createElement(
	      'div',
	      { className: 'rb-about-text' },
	      _react2.default.createElement(
	        'div',
	        { className: 'resume-title' },
	        'Jody Boucher'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'resume-subtitle' },
	        'Software Developer'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'resume-buttons' },
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'resume-button',
	            target: '_blank',
	            rel: 'noopener noreferrer',
	            href: '/' + resumeBasic
	          },
	          _react2.default.createElement(_Icon2.default, { type: 'IconDownload', className: 'resume-icon-download', height: '16', width: '16' }),
	          'PDF (traditional format)'
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'resume-button',
	            target: '_blank',
	            rel: 'noopener noreferrer',
	            href: '/' + resumeModern
	          },
	          _react2.default.createElement(_Icon2.default, { type: 'IconDownload', className: 'resume-icon-download', height: '16', width: '16' }),
	          'PDF (modern format)'
	        )
	      )
	    )
	  );
	};
	
	exports.default = ResumeHeader;
	module.exports = exports['default'];

/***/ }),

/***/ 676:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _StarRating = __webpack_require__(678);
	
	var _StarRating2 = _interopRequireDefault(_StarRating);
	
	__webpack_require__(135);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResumeRating = function ResumeRating(_ref) {
	  var skill = _ref.skill,
	      rating = _ref.rating;
	  return _react2.default.createElement(
	    'div',
	    { key: skill, className: 'resume--section--block' },
	    _react2.default.createElement(
	      'h2',
	      { className: 'resume--section--block-title' },
	      skill
	    ),
	    _react2.default.createElement(_StarRating2.default, { value: rating })
	  );
	};
	
	ResumeRating.propTypes = {
	  skill: _propTypes2.default.string.isRequired,
	  rating: _propTypes2.default.number.isRequired
	};
	
	exports.default = ResumeRating;
	module.exports = exports['default'];

/***/ }),

/***/ 677:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Rating = __webpack_require__(676);
	
	var _Rating2 = _interopRequireDefault(_Rating);
	
	__webpack_require__(135);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var skills = {
	  'C#': 4.5,
	  JavaScript: 4,
	  PHP: 4,
	  Python: 4,
	  'ASP.NET MVC': 4.5,
	  Django: 4,
	  Laravel: 4,
	  'Node.js / Express': 3,
	  Yii: 3,
	  HTML: 4.5,
	  CSS: 4,
	  Sass: 3,
	  HTTP: 4,
	  AJAX: 3.5,
	  'React/Redux': 3.5,
	  AWS: 3,
	  Heroku: 4,
	  Nginx: 3,
	  IIS: 3,
	  PostgreSQL: 3,
	  'SQL Server': 3
	};
	
	var ResumeRatings = function ResumeRatings() {
	  return _react2.default.createElement(
	    'section',
	    null,
	    _react2.default.createElement(
	      'h1',
	      { className: 'resume--aside-title' },
	      'Technical Highlights'
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      Object.keys(skills).map(function (key) {
	        return _react2.default.createElement(_Rating2.default, { skill: key, rating: skills[key] });
	      })
	    )
	  );
	};
	
	exports.default = ResumeRatings;
	module.exports = exports['default'];

/***/ }),

/***/ 678:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(97);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StarRating = function (_React$Component) {
	  _inherits(StarRating, _React$Component);
	
	  function StarRating() {
	    _classCallCheck(this, StarRating);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  StarRating.renderIcon = function renderIcon(index, value) {
	    var star = 'IconStar';
	
	    if (value < index) {
	      star = 'IconEmptyStar';
	    }
	
	    if (Math.ceil(value) === index && value % 1 !== 0) {
	      star = 'IconHalfStar';
	    }
	
	    return _react2.default.createElement(_Icon2.default, {
	      type: star,
	      key: index,
	      className: 'resume-rating',
	      title: 'Rating: ' + value,
	      'data-value': index,
	      height: 16,
	      width: 16
	    });
	  };
	
	  StarRating.prototype.renderStars = function renderStars() {
	    var _props = this.props,
	        value = _props.value,
	        maxValue = _props.maxValue;
	
	    // populate stars
	
	    var starNodes = [];
	    for (var starIndex = 1; starIndex <= maxValue; starIndex += 1) {
	      var starNode = StarRating.renderIcon(starIndex, value);
	      starNodes.push(starNode);
	    }
	
	    return starNodes;
	  };
	
	  StarRating.prototype.render = function render() {
	    var _props2 = this.props,
	        className = _props2.className,
	        value = _props2.value;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: className, title: 'Rating: ' + value, 'data-rating': value },
	      this.renderStars()
	    );
	  };
	
	  return StarRating;
	}(_react2.default.Component);
	
	StarRating.propTypes = {
	  className: _propTypes2.default.string,
	  maxValue: _propTypes2.default.number,
	  value: _propTypes2.default.number
	};
	StarRating.defaultProps = {
	  className: '',
	  maxValue: 5,
	  value: 0
	};
	exports.default = StarRating;
	module.exports = exports['default'];

/***/ }),

/***/ 679:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(135);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResumeSummary = function ResumeSummary() {
	  return _react2.default.createElement(
	    'section',
	    { className: 'resume--section' },
	    _react2.default.createElement(
	      'h1',
	      { className: 'resume--section-title' },
	      'Summary'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'I am a software developer with experience serving both the private and public sectors. I am passionate about technology and crafting simple solutions to complex challenges. I believe in writing code that is clean, clear and deliberate.'
	    )
	  );
	};
	
	exports.default = ResumeSummary;
	module.exports = exports['default'];

/***/ }),

/***/ 135:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 680:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Header = __webpack_require__(675);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Summary = __webpack_require__(679);
	
	var _Summary2 = _interopRequireDefault(_Summary);
	
	var _Experience = __webpack_require__(674);
	
	var _Experience2 = _interopRequireDefault(_Experience);
	
	var _Education = __webpack_require__(673);
	
	var _Education2 = _interopRequireDefault(_Education);
	
	var _Ratings = __webpack_require__(677);
	
	var _Ratings2 = _interopRequireDefault(_Ratings);
	
	var _Seo = __webpack_require__(98);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resume = function Resume(props) {
	  var pageSeo = {
	    type: 'WebPage',
	    title: "Jody Boucher's Resume",
	    description: "Read and download Jody's Resume."
	  };
	  var pagePath = props.location.pathname;
	
	  return _react2.default.createElement(
	    'article',
	    { className: 'resume-container' },
	    _react2.default.createElement(_Seo2.default, { pageSeo: pageSeo, pagePath: pagePath }),
	    _react2.default.createElement(
	      'div',
	      { className: 'resume-wrapper resume-content' },
	      _react2.default.createElement(
	        'header',
	        { className: 'site-page--header' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'site-page--title' },
	          'Resume'
	        )
	      ),
	      _react2.default.createElement(_Header2.default, null),
	      _react2.default.createElement(_Summary2.default, null),
	      _react2.default.createElement(_Experience2.default, null),
	      _react2.default.createElement(_Education2.default, null)
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'resume-sidebar' },
	      _react2.default.createElement(
	        'aside',
	        { className: 'resume--aside' },
	        _react2.default.createElement(
	          'div',
	          { className: 'resume-wrapper' },
	          _react2.default.createElement(_Ratings2.default, null)
	        )
	      )
	    )
	  );
	};
	
	Resume.propTypes = {
	  location: _propTypes2.default.shape({
	    pathname: _propTypes2.default.string.isRequired
	  }).isRequired
	};
	
	exports.default = Resume;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-resume-index-js-9593aefeda1ab2d5d6a9.js